module.exports = ".Account{margin-top:30px}\n"